import React from "react";

const NotValidTab = () => {
  return (
        <div className="text-center pt-4">
          <h6>Page Not Found</h6>
        </div>
  );
};

export default NotValidTab;
